import { css } from '@emotion/react'
 /** @jsxImportSource @emotion/react */
import React,{useState} from 'react'
import { Form, Input ,Select } from 'antd';
import {ButtonBase} from '@mui/material';
import axios from '../apiClient';
import Alert from '../alert';
import Loader from '../loader';
import { useLocation } from 'react-router-dom';

export default function EditUser() {
  const [loading,setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const location = useLocation();
  // console.log(location.state)
  const {id: masterId} = location.state;
  
  const onFinish = async (values) => {
    let {
      phNum: phoneNumber,password,
      singleBigMatchCommission,
      singleSmallMatchCommission,
      twoMixParlayCommission,
      threeToEightMixParlayCommission,
      nineToElevenMixParlayCommission
    }  = values;
    setLoading(true)

    if(!password) password = "";
    const params ={masterId,phoneNumber,password,
                  singleBigMatchCommission,
                  singleSmallMatchCommission,
                  twoMixParlayCommission,
                  threeToEightMixParlayCommission,
                  nineToElevenMixParlayCommission
                  }
    const data = await axios.put(`/master/editMaster`,params)

    setErrorMsg({ code: data.code, msg: data.message })
    setLoading(false)
    setOpenAlert(true)
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
  return (
    <div
      css={css`
        /* background-color: #ffffff; */
        border-radius: 1rem;
        margin: 0 10rem;
        padding: 1rem;
      `}
    >
        {/* <h2 style={{fontWeight: 'normal',marginBottom: "2rem"}}>Edit User</h2> */}
      <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
      <Form
        name="basic"
        className="create-user"
        style={{
          fontFamily: "inherit",
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Upper />
        <Lower />
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            padding: "0 2rem",
            marginTop: "2rem",
          }}
        >
          <ButtonBase
            type="submit"
            component="button"
            style={{
              color: "white",
              display: "flex",
              backgroundColor: "#5e35b1",
              padding: "0.6rem 1.8rem",
              borderRadius: "2rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
             {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 }}>Edit</h4>}
          </ButtonBase>
        </div>
      </Form>
    </div>
  );
}

const Upper = () =>{
  const location = useLocation();
  const {name,phone_number} = location.state;
  const validatePassword = (_, value) => {
    if (value && !/(?=.*[A-Z])(?=.*\d).{8,}/.test(value)) {
      return Promise.reject(
        'Password must contain at least one capital letter, one number, and be at least 8 characters long'
      );
    }
    return Promise.resolve();
  };
  return (
    <div
    css={css`
    /* background-color: #EEEEEE; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
  `}
    >
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Username"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="username"
          style={{ padding: "0 0.4rem", color: "white" }}
          initialValue={name}
          
        >
          <Input
            css={css`
              :hover {
                border-color: red;
              }
            `}
            size="large"
            disabled
          />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Phone Number"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="phNum"
          style={{ padding: "0 0.4rem", color: "white" }}
          initialValue={phone_number}
        >
          <Input  size="large" />
        </Form.Item>
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Password"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="password"
          hasFeedback
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              validator: validatePassword
            },
          ]}
        >
          <Input.Password
            css={css`
              :hover {
                border-color: red;
              }
            `}
            size="large"
          />
        </Form.Item>
      
      </div>

    </div>
  );
}

const Lower = () =>{
  const location = useLocation();
  const {ssmc,sbmc,tmpc,ttempc,ntempc} = location.state;
  return (
    <div
    css={css`
    /* background-color: #EEEEEE; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
  `}
    >
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Single Small Match Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="singleSmallMatchCommission"
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              required: true,
              message: `Please input commission!`,
            },
          ]}
          initialValue={ssmc}
        >
          <Input size="large" />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Single Big Match Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="singleBigMatchCommission"
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              required: true,
              message: `Please input commission!`,
            },
          ]}
          initialValue={sbmc}
        >
          <Input  size="large" />
        </Form.Item>
       
      
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="2 Parlay Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="twoMixParlayCommission"
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              required: true,
              message: `Please input commission!`,
            },
          ]}
          initialValue={tmpc}
        >
          <Input  size="large" />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="3 to 8 Parlay Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="threeToEightMixParlayCommission"
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              required: true,
              message: `Please input commission!`,
            },
          ]}
          initialValue={ttempc}
        >
          <Input  size="large" />
        </Form.Item>
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="9 to 11 Parlay Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="nineToElevenMixParlayCommission"
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              required: true,
              message: `Please input commission!`,
            },
          ]}     
          initialValue={ntempc}
        >
          <Input size="large" />
        </Form.Item>
      </div>
    </div>
  );
}